import { X } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarCartItem } from './NavBarCartItem';

import { Link } from 'react-router-dom';
import {
  fetchCart,
  getTotalCartPrice,
  getTotalCartQuantity,
} from '../../../features/cart/cartSlice';
import { Subtotal } from './Subtotal';
import { getUserIsAuthenticated } from '../../../features/auth/authSlice';

const CartDropdownItems = ({ isOpen, setIsOpen }) => {
  const CartQuantity = useSelector(getTotalCartQuantity);
  const [internalOpen, setInternalOpen] = useState(false);
  const subTotal = useSelector(getTotalCartPrice);
  const isAuthenticated = useSelector(getUserIsAuthenticated);
  const [successModalIsOpen, setSuccessModalIsOpen] = useState(false);

 
  const user = useSelector((state) => state.user);
  const isTier2 = user?.data?.isTier2
  const menuRef = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCart());
  }, [dispatch]);

  const { cart: cartItems, loading } = useSelector((state) => state.cart);

  const plans = [...new Set(cartItems.map((i) => i.selectedPaymentPlan))];
  const isValid =
    plans.length === 1 || (plans.includes('full') && plans.length === 2);

  useEffect(() => {
    if (isOpen) {
      setInternalOpen(true);
    } else {
      const timer = setTimeout(() => setInternalOpen(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target) && isOpen) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  if (!internalOpen) return null;


const needToUpgrade = subTotal > 500000 && (!isAuthenticated || isTier2 !== true);
const shouldDisableCheckout = needToUpgrade;



  return (
    <>
      <div
        className={`fixed inset-0 bg-opacity-50 z-40 transition-opacity duration-300 ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsOpen(false)}
      />

      <div
        ref={menuRef}
        className={`shadow-2xl fixed w-full md:w-[420px] h-screen right-0 bg-white z-50  top-[130px] md:top-[77px] transform transition-all duration-300 ease-in-out ${
          isOpen ? 'translate-y-0 opacity-100' : 'translate-y-[-5%] opacity- 0'
        }`}
      >
        <div className="flex justify-between items-center px-5 mb-5">
          <p className="hidden md:flex min-w-fit pt-4 font-medium">
            Cart Summary
          </p>
          <p className="min-w-fit pt-4 font-medium md:hidden">Shopping Cart</p>

          <button
            className="w-full flex justify-end pt-4"
            onClick={() => setIsOpen(false)}
          >
            <X className="hidden md:flex w-5 h-5" />
          </button>
        </div>

        <hr className="my-3" />

        <section
          className="px-5 overflow-y-auto"
          style={{ height: 'calc(100vh - 280px)' }}
        >
          {cartItems.length >= 1 ? (
            <div className="flex justify-between items-center">
              <p className="text-[#16161A]">
                You have {cartItems.length}{' '}
                {cartItems.length > 1 ? 'items' : 'item'} in your cart.
              </p>
              <Link to="/cart-items" className="underline ">
                View cart
              </Link>
            </div>
          ) : (
            <div className="flex flex-col justify-between md:h-scree">
              <p className="hidden text-[#16161A] md:flex items-center font-semibold">
                Your cart is empty.
              </p>

              <div className="md:hidden flex flex-col justify-center h-full text-center mt-6">
                <p className="text-[#16161A] flex items-center font-semibold justify-center mb-3">
                  Your shopping cart is empty
                </p>
                <Link
                  to="/"
                  className="underline mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  Shop
                </Link>
                <Link
                  to="/home-living"
                  className="underline mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  {' '}
                  Home & Living
                </Link>
                <Link
                  to="/lifestyle"
                  className="underline mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  {' '}
                  Lifestyle & Consumer goods
                </Link>
                <Link
                  to="/electronics"
                  className="underline"
                  onClick={() => setIsOpen(false)}
                >
                  {' '}
                  Electronics
                </Link>
              </div>
            </div>
          )}

          <ul className="pb-40 lg:pb-32 pt-4">
            {cartItems?.map((item, index) => (
              <NavBarCartItem item={item} key={index} />
            ))}
          </ul>
        </section>

        {cartItems.length >= 1 && (
          <div className="sticky bottom-0 left-0 right-0 w-full md:w-[420px] md:right-0 md:left-auto">
            <Subtotal
              isValid={isValid}
              needToUpgrade={needToUpgrade}
              shouldDisableCheckout={shouldDisableCheckout}
              subTotal={subTotal}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CartDropdownItems;